

export default {
  name: 'BbMultipleOptionButtons',
  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedClassList() {
      return {
        'bb-options-buttons--full-width': this.fullWidth,
      };
    },
  },
};
